import React from 'react';
import '../styles/TileCard.css';

interface TileCardProps {
  image: string;
  title: string;
  description: string;
}

const TileCard: React.FC<TileCardProps> = ({ image, title, description }) => {
  return (
    <div className="tile-card">
      <img src={image} alt={title} className="tile-image" />
      <div className="tilecard-content">
        <h3 className="tilecard-title">{title}</h3>
        <p className="tilecard-description">{description}</p>
      </div>
    </div>
  );
};

export default TileCard;
